import { cn } from "@/lib/utils";
import type { Passenger } from "@/types/booking-history/bookinghistorydetail";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

type PassengerDetailsCardProps = {
  passengers: Passenger[];
  paymentId: string | undefined;
};

export function PassengerDetailsCard({
  passengers,
  paymentId,
}: PassengerDetailsCardProps) {
  return (
    <>
      <h2 className="mt-8 text-lg font-semibold text-secondary-foreground">
        Passenger Details
      </h2>
      <section className="overflow-hidden rounded-2xl bg-card shadow-xl mt-2">
        <div className="grid grid-cols-[1rem_1fr_auto] gap-4 bg-primary px-4 py-2 text-xs font-medium text-primary-foreground md:grid-cols-[3rem_1fr_auto] md:text-sm md:px-6">
          <span>No.</span>
          <span>Name</span>
          <span className="text-end mr-4">Action</span>
        </div>
        <div className="flex flex-col px-4 md:px-6">
          {passengers.map((passenger, index) => (
            <div
              key={passenger.paymentTicketId}
              className={cn(
                "grid grid-cols-[1rem_1fr_auto] items-center gap-4 py-4 text-xs font-medium text-secondary-foreground md:grid-cols-[3rem_1fr_auto] md:text-sm",
                index !== 0 && "border-t border-border",
              )}
            >
              <span className="text-muted-foreground">{index + 1}</span>
              <span className="text-muted-foreground">
                {passenger.passengerIdentityName ?? passenger.name}
              </span>
              <Link
                to={`/booking-history/passenger/${paymentId}`}
                state={{
                  passengers,
                  passengerIndex: index,
                }}
                className="group flex items-center text-primary gap-1 text-xs font-medium md:text-sm"
              >
                {passenger.passengerIdentityName == null
                  ? "Add Details"
                  : "Edit Details"}
                <ChevronRight
                  size={18}
                  className="group-hover:translate-x-1 transition-transform duration-200 ease-in-out"
                  aria-hidden="true"
                />
              </Link>
            </div>
          ))}
          {passengers.length === 0 && (
            <p className="text-sm text-muted-foreground">
              No passengers available for this booking.
            </p>
          )}
        </div>
      </section>
    </>
  );
}
